import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileProfileActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.6666 14.666C13.4029 14.666 14.0147 14.0619 13.8524 13.3436C13.6044 12.2463 13.0506 11.2315 12.2425 10.4234C11.1173 9.29816 9.5912 8.66602 7.9999 8.66602C6.4086 8.66602 4.88248 9.29816 3.75726 10.4234C2.94917 11.2315 2.39539 12.2463 2.14742 13.3436C1.98511 14.0619 2.59685 14.666 3.33323 14.666H12.6666Z",
		fill: "#2667FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.6663 4.00065C10.6663 5.47341 9.47243 6.66732 7.99967 6.66732C6.52692 6.66732 5.33301 5.47341 5.33301 4.00065C5.33301 2.52789 6.52692 1.33398 7.99967 1.33398C9.47243 1.33398 10.6663 2.52789 10.6663 4.00065Z",
		fill: "#2667FF"
	})]
});
export default SvgMobileProfileActive;
